export const URL_GAME_HUB = 'https://remitano.com/home/vn/gamehub';
export const URL_HOMEPAGE = 'https://remitano.com';
